import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ENV_VARS } from 'ENV_CONFIG';
import qs from 'qs';

import { envConfigSelectors } from '~/components';
import { appointmentDraftSelectors } from '~/api';
import { routerSelectors } from '~/selectors';

export const withRedirection = (Component) =>
  class extends PureComponent {
    static displayName = 'WithRedirection';

    static propTypes = {
      appointmentType: PropTypes.shape({
        deprecationRedirectUrl: PropTypes.string,
      }),
      pathname: PropTypes.string.isRequired,
      excludedPaths: PropTypes.arrayOf(PropTypes.string),
    };

    static defaultProps = {
      appointmentType: null,
      excludedPaths: [],
    };

    componentDidMount() {
      this.checkRedirection();
    }

    componentDidUpdate() {
      this.checkRedirection();
    }

    checkRedirection = () => {
      const { appointmentType } = this.props;

      if (this.isPageExcluded()) {
        return;
      }

      if (!appointmentType || appointmentType.deprecationRedirectUrl) {
        if (this.isChildrensShoesRoute() && this.hasDeprecatedChildrensShoesAppointmentId()) {
          window.location.replace('/appointments/childrens-shoe-fitting/fitting-type');
          return;
        }
        if (this.isPiercingRoute()) {
          const type = this.getPiercingType();
          window.location.replace(`/appointments/piercing/${type}`);
          return;
        }
        const redirectUrl = appointmentType?.deprecationRedirectUrl || '/our-services';
        window.location = `${ENV_VARS.REACT_APP_BROWSE_HOST}${redirectUrl}`;
      }
    };

    isChildrensShoesRoute() {
      return window.location?.pathname?.includes('childrens-shoe-fitting');
    }

    isPiercingRoute() {
      return window.location?.pathname?.includes('piercing');
    }

    getPiercingType() {
      const pathName = window.location?.pathname;
      const weldingType = 'welding-type';
      let type = 'piercing-type';
      if (pathName?.includes(weldingType)) {
        type = weldingType;
      }
      return type;
    }

    hasDeprecatedChildrensShoesAppointmentId() {
      const urlParams = new URLSearchParams(window.location.search);
      const appointmentTypeId = urlParams.get('appointmentTypeId');
      return ['54612', '55326', '55330', '54614', '55346', '55350'].includes(appointmentTypeId);
    }

    isPageExcluded = () => {
      const { excludedPaths, pathname } = this.props;
      return [
        '/review',
        '/edit-shop',
        '/edit-address',
        '/edit-date',
        '/edit-your-details',
        '/edit-question-answers',
        '/about-you',
        '/completed-booking',
        '/bookings',
        ...excludedPaths,
      ].some((excludedPath) => pathname.indexOf(excludedPath) === 0);
    };

    render() {
      return <Component {...this.props} />;
    }
  };

export const mapStateToProps = (state) => {
  const { appointmentTypeId } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const draftAppointmentTypeId = appointmentDraftSelectors.selectAppointmentTypeId(state);
  return {
    appointmentType: envConfigSelectors.appointmentTypeConfigByServiceNameAndAppointmentTypeId(
      appointmentTypeId || draftAppointmentTypeId,
    )(state),
    pathname: routerSelectors.selectLocationPathname(state),
    excludedPaths: envConfigSelectors.selectExcludedRedirectionPaths(state),
  };
};

export const ConnectedWithRedirection = (Component) =>
  connect(mapStateToProps)(withRedirection(Component));
